import { Alert, Extendable } from 'model';
import Account from './Account';
import { PermissionsEnum } from './Role';
import Device from './Device';
import { Notifications } from './Notification';
import { SystemMode } from './SystemMode';
import i18n from 'i18next';
import { LocationFilterState } from './state';

export interface LocationSystemMode {
  target: SystemMode
}

export enum LocationType {
  UNIT,
  PROPERTY,
  REGION,
  BUILDING, 
}

export interface Coords {
  latitude: number;
  longitude: number;
}

interface GeoLocation {
  coordinates?: Coords;
}

export interface Location {
  id?: string;
  address?: string;
  address2?: string;
  city?: string;
  state?: string;
  country: string;
  postalCode?: string;
  timezone: string;
  nickname: string;
  type: LocationType;
  notifications?: Notifications;
  isProfileComplete?: boolean;
  parent?: Extendable<Location> | null;
  children: Extendable<Location>[];
  account?: Account;
  roles?: PermissionsEnum[];
  hasInheritedRolesOnly?: boolean;
  systemMode?: LocationSystemMode;
  alerts?: Alert[];
  geoLocation?: GeoLocation;
}

export interface Unit extends Location {
  devices?: Device[];
}

interface ThresholdVolume {
  value: number;
}

interface ThresholdDuration {
  value: number; 
}

export interface ThresholdSetting {
  volume: ThresholdVolume; 
  duration: ThresholdDuration;
}

export interface Alarmsettings {
  smsEnabled?: boolean; 
  emailEnabled?: boolean;
  callEnabled?: boolean;
}

export function filterPhantomLocations(locations: Location[]): Location[] {
  return locations.filter(loc => loc.isProfileComplete || loc.nickname || loc.address || loc.city)
}

export function typeToString(type: LocationType): string {
  switch(type) {
    case LocationType.UNIT:
      return i18n.t('Unit');
    case LocationType.PROPERTY:
      return i18n.t('Property');
    case LocationType.BUILDING:
      return i18n.t('Building');
    case LocationType.REGION:
      return i18n.t('Community');
  }
}


export type LocationFilters = Partial<LocationFilterState>;

export enum LocationFacetType {
  CITY,
  STATE,
  COUNTRY,
  POSTAL_CODE,
  CLASS
}

export interface LocationFacet {
  userId:   string;
  type?:    LocationFacetType;
  search:   string;
  page?:    number;
}

export type LocationMap = { [locationId: string]: Location };

export default Location;
